<app-client-autocomplete
  id="tenantThemeClient"
  [selectedClient]="selectedClient"
  (selectedClientChange)="onSelectedClientChange($event)"
  [placeholder]="'i18n.domain.theme-showcase.select-client' | translate">
</app-client-autocomplete>

<ejs-dialog
  [isModal]="true"
  [showCloseIcon]="false"
  [visible]="isUnsavedChangesDialogOpen"
  width="460px"
  cssClass="modal-sm"
  [allowDragging]="false">
  <ng-template #header>
    {{ 'i18n.domain.theme-showcase.tenantTheme.unsavedChanges.title' | translate }}
  </ng-template>
  <ng-template #content>
    {{ 'i18n.domain.theme-showcase.tenantTheme.unsavedChanges.content' | translate }}
  </ng-template>
  <ng-template #footerTemplate>
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancelClientSwitch()">
      {{ 'i18n.domain.theme-showcase.tenantTheme.unsavedChanges.cancelButton' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmClientSwitch()">
      {{ 'i18n.domain.theme-showcase.tenantTheme.unsavedChanges.confirmButton' | translate }}
    </button>
  </ng-template>
</ejs-dialog>




